<template lang="pug">
    footer
        .columns
            .column.is-four-fifth.address
                p Gütesiegelverbund Weiterbildung e.V.
                p Huckarder Straße 12
                p 44147 Dortmund
            .column.is-one-fifth
                nav#footer-menu(v-if="items && items.length")
                    .container
                        tree-menu(:items="items" :max-depth="1" :allow-multiple-active-items="true" :delay="100")
        #va-footer
            small.has-text-centered Erstellt mit CityPage, dem Webbaukasten der
                a(href="https://vanameland.de") Vanameland
</template>

<script>

import _ from 'lodash'
import { mapGetters } from 'vuex'

import NestedSet from '@/nested-set-lib'

export default{
    name: 'Footer',
    computed: {
        items() {
            const menu = this.menus.find(menu => menu.key === 'footer-menu')
            let items = _.get(menu, 'menuItems') || []
            items = _.cloneDeep(items)

            if (items.length) {
                return NestedSet.createTree(items)
            }

            return items
        },
        ...mapGetters({
            menus: 'menus',
            config: 'config',
        })
    },
}
</script>

<style lang="sass" scoped>

    @import "~bulma/sass/utilities/mixins";

    footer
        background-color: #074374
        color: #ffffff
        position: relative
        min-height: 30px
        padding-top: 40px
        nav#footer-menu /deep/
            margin-bottom: 30px
            a
                color: #ffffff
            ul
                & > li
                    text-align: center
                    a
                        display: block
                        padding: 10px 20px
                +desktop
                    display: flex
                    flex-direction: column
                    & > li
                        flex-grow: 1
                        flex-basis: 100%
                        text-transform: uppercase
                        // border-bottom: 1px solid #3b578a
                        &:last-child
                            // border-bottom: none
                        a
                            // height: 100px
                            display: flex
                            justify-content: center
                            align-items: center
                        &.visible
                            a
                                background-color: #3b578a
        div#va-footer
            font-size: .8rem
            padding: 10px 0
            text-align: center
            background-color: rgba(0, 0, 0, .2)
            +desktop
                background-color: initial
                position: absolute
                bottom: 0
                font-size: .9rem
                color: #fff
                width: 100%
                text-align: center
            a
                color: #fff
    .address
        padding-left: 150px
        padding-top: 25px
        +mobile
            padding: 25px 0 0 0
            text-align: center
</style>
